module.exports = __webpack_public_path__ + "img/image-2.4b433e78.webp";